import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { isEmpty, get } from 'lodash';
import EnhnacementsPerPerson from './EnhnacementsPerPerson';
import ServicePerPerson from './ServicePerPerson';
import SoothePassInCart from './SoothePassInCart';
import SoothePassPromotion from './SoothePassPromotion';
import { isEventBooking } from '../../../constants';

class Appointments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.relevantTitle = this.relevantTitle.bind(this);
  }

  relevantTitle() {
    const alreadyAppliedToCart = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_applied_to_cart', false);
    if (isEventBooking()) {
      return null;
    }
    return (<div className="second-title-style medium-font">{alreadyAppliedToCart ? 'Your Cart' : 'Appointment'}</div>);
  }

  render() {
    const cart = get(this.props, 'booking.cart', null);
    const is_event = get(cart, 'is_event', false);
    const cartProducts = is_event ? [get(cart, 'cartProducts.0', null)] : get(cart, 'cartProducts', []);
    const alreadyAppliedToCart = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_applied_to_cart', false);
    if (!isEmpty(cartProducts)) {
      return (
        <div>
          {this.relevantTitle()}
          {!isEventBooking() ? <SoothePassInCart assignToCart={this.props.assignToCart} /> : null}
          {cartProducts.map((cartProduct, it) => (
            <div key={`selection-${it}`}>
              <ServicePerPerson
                cartProduct={cartProduct}
                deleteRelevantService={this.props.deleteRelevantService}
                openPlanPopup={this.props.openPassPlanPopup}
              />
              {!isEventBooking() && it === cartProducts.length - 1 && !alreadyAppliedToCart ? <SoothePassPromotion openPlanPopup={this.props.openPassPlanPopup} /> : null}
              {!isEventBooking() ? <EnhnacementsPerPerson
                cartProduct={cartProduct}
                productIteration={it}
                productEnhancements={get(this.props.enhancementsByProductId, cartProduct.id, [])}
                enhancementClick={this.props.enhancementClick}
              /> : null}
            </div>
          ))}
        </div>
      );
    }
    return null;
  }
}
const mapStateToProps = (state) => ({
  booking: state.booking,
  addresses: state.addresses,
  client: state.client,
});

Appointments.propTypes = {
  booking: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
};

export default withLocalize(connect(mapStateToProps)(Appointments));
